(function () {
  var footer = document.querySelector('.footer');
  if (!footer) return;

  var lastScrollY = window.scrollY;
  var threshold = 8;
  var atBottomTolerance = 4;

  function onScroll() {
    var currentScrollY = window.scrollY;
    var delta = currentScrollY - lastScrollY;
    var atPageBottom = (window.innerHeight + currentScrollY) >= (document.documentElement.scrollHeight - atBottomTolerance);

    if (atPageBottom) {
      footer.classList.remove('oi-footer--hidden');
    } else if (Math.abs(delta) > threshold) {
      if (delta > 0 && currentScrollY > 40) {
        footer.classList.add('oi-footer--hidden');
      } else if (delta < 0) {
        footer.classList.remove('oi-footer--hidden');
      }
      lastScrollY = currentScrollY;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
})();
